import React from 'react'
import styled from 'styled-components'


const Map = () => {
    const mapLocation = {
        map1: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3817.624688462359!2d42.5532051!3d16.894450499999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1607e3d70adce3a3%3A0x227b9ed799ee5a4b!2z2LPYrdin2Kgg2KfZhNi52KfZhNmFINmE2YTYs9mB2LEg2YjYp9mE2LPZitin2K3YqQ!5e0!3m2!1sen!2s!4v1702556192742!5m2!1sen!2s",
    }
    return (
        <MapWapper className='mapWrapper'>
            <iframe src={mapLocation.map1} height='100%' border='0' allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </MapWapper>
    )
}
const MapWapper = styled.div`
    height: 100%;
    padding: 73px 0 96px 0;
    iframe{
        border-radius: 20px;
        width: 100%;
        height: 100%;
        border: 0;
        
    }
`

export default Map
